import LanguageContext from "components/LanguageContext";
import Wrapper from "components/LayoutFront/Wrapper";
import Link from "components/templatesComponents/Link";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import t from "utils/locales/translation.json";

const scrollerStyled = {
  mx: "auto",
  width: "100%",
  zIndex: "250",
  boxSizing: "border-box",
  "@media print": {
    display: "none",
  },
};

const BackToTop = () => {
  const { language } = useContext(LanguageContext);

  return (
    <Wrapper sx={scrollerStyled} className="fr-grid-row fr-grid-row--right fr-pt-20v">
      <Link
        id="backToTop"
        className="fr-link fr-icon-arrow-up-fill fr-link--icon-left"
        aria-label={t[language].components.back_to_top_icon_title}
        anchor={"top"}
      >
        {t[language].common.top_of_page}
      </Link>
    </Wrapper>
  );
};

BackToTop.propTypes = {
  url: PropTypes.string,
};

export default BackToTop;
